export default __webpack_public_path__ + "static/media/empty_tabAktifitas.05febc71.svg";